

















import { Component, Vue } from 'vue-property-decorator';
import { dispatchCheckLoggedIn, readIsLoggedIn } from '@/store/main/accessors';
import NotificationsManager from '@/components/NotificationsManager.vue';
import OverlayProgress from '@/components/OverlayProgress.vue';

@Component({
  components: {
    NotificationsManager,
    OverlayProgress,
  },
})
export default class App extends Vue {
  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }

  public async created() {
    await dispatchCheckLoggedIn(this.$store);
  }
}
